import { defaultQueryParamKeys, DateRangeFilter } from '@cast/shared-date-ui';

export const DASHBOARD_CHART_HEIGHT = 320;

export const DASHBOARD_CHART_TIMEZONE = 'UTC';

export const DASHBOARD_CHART_MAX_DAYS = 93;

export const DASHBOARD_CHART_ZOOM_QUERY_PARAM_KEYS = {
  fromDate: defaultQueryParamKeys.fromDate,
  toDate: defaultQueryParamKeys.toDate,
  dateRangePreset: defaultQueryParamKeys.dateRangePreset,
};

export const DASHBOARD_RANGE_PICKER_SX = { minWidth: 196 } as const;

export const dashboardChartFilterPresets = [
  DateRangeFilter.Last7Days,
  DateRangeFilter.Last30Days,
  DateRangeFilter.ThisMonth,
  DateRangeFilter.Last3Months,
  DateRangeFilter.PreviousMonth,
] as const;
